'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { MultiSelectWithGroups } from '../../components';
import { useTableFilters } from '../useTableFilters';
import type { MultiSelectGroup } from '../../components';
import type { ComponentProps } from 'react';
import type { BaseTableFilterProps } from './types';
export interface MultiSelectWithGroupsTableFilterProps extends BaseTableFilterProps {
  groups: MultiSelectGroup[];
  searchParam: string;
  variant: 'multiSelectWithGroups';
  componentProps?: Partial<ComponentProps<typeof MultiSelectWithGroups>>;
  placeholder?: string;
  filterOptions?: never;
  value?: never;
  fromDateParam?: never;
  toDateParam?: never;
}
export function MultiSelectWithGroupsTableFilter(t0) {
  const $ = _c(17);
  const {
    className,
    searchParam,
    searchParamsToClearOnChange,
    componentProps,
    groups,
    placeholder,
    filterType: t1
  } = t0;
  const filterType = t1 === undefined ? "rsc" : t1;
  const searchParams = useSearchParams();
  const {
    updateMultiSelectFilter
  } = useTableFilters(filterType);
  const parseUrlParamToObject = _temp;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [selectedMultiValues, setSelectedMultiValues] = useState(t2);
  let t3;
  let t4;
  if ($[1] !== searchParam || $[2] !== searchParams) {
    t3 = () => {
      const urlValue = parseUrlParamToObject(searchParams?.get(searchParam) ?? null);
      setSelectedMultiValues(urlValue);
    };
    t4 = [searchParams, searchParam];
    $[1] = searchParam;
    $[2] = searchParams;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== groups || $[6] !== searchParam || $[7] !== searchParamsToClearOnChange || $[8] !== updateMultiSelectFilter) {
    t5 = function handleMultiSelectChange(values) {
      setSelectedMultiValues(values);
      updateMultiSelectFilter(searchParam, values, searchParamsToClearOnChange, groups);
    };
    $[5] = groups;
    $[6] = searchParam;
    $[7] = searchParamsToClearOnChange;
    $[8] = updateMultiSelectFilter;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleMultiSelectChange = t5;
  if (!groups) {
    return null;
  }
  let t6;
  if ($[10] !== className || $[11] !== componentProps || $[12] !== groups || $[13] !== handleMultiSelectChange || $[14] !== placeholder || $[15] !== selectedMultiValues) {
    t6 = <MultiSelectWithGroups {...componentProps} className={className} groups={groups} onSelectionChange={handleMultiSelectChange} placeholder={placeholder} selectedValues={selectedMultiValues} />;
    $[10] = className;
    $[11] = componentProps;
    $[12] = groups;
    $[13] = handleMultiSelectChange;
    $[14] = placeholder;
    $[15] = selectedMultiValues;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp(paramValue) {
  if (!paramValue) {
    return {};
  }
  const entries = paramValue.split(",");
  const result = {};
  entries.forEach(entry => {
    if (entry.includes(":")) {
      const [groupId, optionValue] = entry.split(":", 2);
      if (groupId && optionValue) {
        if (!result[groupId]) {
          result[groupId] = [];
        }
        result[groupId].push(optionValue);
      }
    } else {
      const groupId_0 = entry;
      if (groupId_0) {
        result[groupId_0] = ["selected"];
      }
    }
  });
  return result;
}